import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
  PERFIL_ADMIN, getAdminEmpresa, getGestorEmpresa
} from '../../security/securityContext';
import Autorizacao, { validaPerfis } from '../../security/Autorizacao';
import {tipoControleEmissaoBPe} from '../../util/constantsUtil';

export class ConfiguracaoBpe extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      configuracaoSelecionada: null,
    };
  }

  selecionarEmpresa (configuracao) {
    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'codigoConfiguracaoBPe', configuracao.id);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'sePodeAlterarNumeracao', configuracao.sePodeAlterarNumeracao);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'numeracao', configuracao.numeracao);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'codigoEmpresa', configuracao.codigoEmpresa);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'razaoSocial', configuracao.razaoSocial);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'nomeFantasia', configuracao.nomeFantasia);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'email', configuracao.email);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'cnpj', configuracao.cnpj);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'ie', configuracao.ie);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'im', configuracao.im);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'cnae', configuracao.cnae);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'tar', configuracao.tar);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'habilitadaBpe', configuracao.habilitadaBpe);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'habilitadoBpe', configuracao.habilitadoBpe);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'nomeCertificado', configuracao.nomeCertificado);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
      'telefone', configuracao.telefone);

    this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'regimeTributario', {
          label: configuracao.regimeTributario.valor,
          value: configuracao.regimeTributario.chave
        });

    if (configuracao.endereco) {

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'cep', configuracao.endereco.cep);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'idEndereco', configuracao.endereco.id);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'logradouro', configuracao.endereco.logradouro);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'complemento', configuracao.endereco.complemento);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'bairro', configuracao.endereco.bairro);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'localidade', configuracao.endereco.localidade);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'uf', configuracao.endereco.uf);

      this.props.changeFieldValue('formCadastrarConfiguracaoBPe',
        'numero', configuracao.endereco.numero);
    }

    if (configuracao.endereco.nomeCidade !== null) {
      const cidadeDeOrigem = {
        id: configuracao.endereco.codigoCidade,
        nome: configuracao.endereco.nomeCidade,
        uf: configuracao.endereco.uf
      }

      this.props.selecionarOrigem(cidadeDeOrigem)
    }
  }

  exibirInativacao () {
    if (this.props.configuracao.seAtivo) {
      return <input data-toggle="modal"
                    id={this.props.configuracao.id}
                    data-target="#ModalConfirmacaoInativacaoConfiguracao"
                    className="checkbox-custom"
                    type="checkbox"
                    defaultChecked={this.props.configuracao.seAtivo}
                    onClick={() => this.props.selecionarConfiguracao(this.props.configuracao)}/>
    }

    return <input id={this.props.configuracao.id}
                  className="checkbox-custom"
                  type="checkbox"
                  defaultChecked={this.props.configuracao.seAtivo}
                  onClick={() => this.props.ativar(this.props.configuracao)}/>
  }

  exibirStatus () {
    if (this.props.configuracao.seAtivo) {
      return (<span className="txt-ativo">Ativo</span>);
    }
    return (<span className="txt-inativo">Inativo</span>);
  }

  render () {
    const perfisPermitidos = validaPerfis([PERFIL_ADMIN]);
    return (
      <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
        getGestorEmpresa(this.props.empresaSelecionada.id),
        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
        <div className="representante">
          <div className="resumo">
            <div className="row">
              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Razão Social:&nbsp;</span>{this.props.configuracao.razaoSocial}
              </div>

              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Nome fantasia:&nbsp;</span>{this.props.configuracao.nomeFantasia}
              </div>

              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">CNPJ/CPF:&nbsp;</span>{this.props.configuracao.cnpj}
              </div>

              <div className="col-lg-2 col-xl-2">
                <span className="titulo-mobile">Inscrição Estadual:&nbsp;</span>{this.props.configuracao.ie}
              </div>

              <div className="col-lg-1 col-xl-1">
                <span className="titulo-mobile">Validade:&nbsp;</span>{this.props.configuracao.dataValidadeCertificado}
              </div>

              <div className="col-lg-1 col-xl-1">
                <span className="titulo-mobile">Estado:&nbsp;</span>{this.props.configuracao.endereco.uf}
              </div>

              <div className="col-lg-2 col-xl-2">
                <div className="acoes">
                  <div className="botoes">
                  { perfisPermitidos && 
                    <button type="button" className="btn btn-editar ml-2"
                            data-toggle="modal"
                            data-target="#modalCadastrarConfiguracaoBPe"
                            onClick={() => this.selecionarEmpresa(this.props.configuracao)}>
                      <i className="material-icons nav-icon">&#xe150;</i>
                    </button>}

                    { perfisPermitidos && 
                    <button type="button" className="btn btn-excluir"
                      data-toggle="modal"
                      data-target="#modalConfirmacaoExclusaoConfiguracaoBpe"
                      title='Excluir'
                      onClick={() => this.props.selecionarConfiguracao(this.props.configuracao)}>
                      <i className="material-icons nav-icon">&#xe872;</i>
                    </button>}

                    {this.props.configuracao.seAtivo && (this.props.regraControleEmissaoBpe == tipoControleEmissaoBPe.horario.value ||
                        this.props.regraControleEmissaoBpe == tipoControleEmissaoBPe.horarioMaisCartao.value) ? (
                    <button type="button" className="btn btn-editar ml-2"
                            data-toggle="modal"
                            data-target="#modalCadastrarControleEmissaoBPe"
                            onClick={() => this.props.selecionarConfiguracao(this.props.configuracao)}
                            >
                      <i className="material-icons add_alarm">&#xe193;</i>
                    </button>
                    ) : (
                        <div>&nbsp;</div>
                    )}

                  </div>
                  
                  <div className="botoes">
                    <span className="titulo-mobile tm-status">Status:&nbsp;</span>
                    <div className="custom-btn-status ativo">
                      { perfisPermitidos && this.exibirInativacao()}
                      <label htmlFor={this.props.configuracao.id} className="checkbox-custom-label"/>
                      {this.exibirStatus()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Autorizacao>
    )
  }
}

export default connect(null, { changeFieldValue })(reduxForm({
  form: 'formCadastrarConfiguracaoBPe'
})(ConfiguracaoBpe))
